import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  Badge,
  MenuItem,
  DropdownButton,
} from 'react-bootstrap';

export const FILTER_NAMES = {
  AC: 'Active',
  AR: 'Archived',
  DR: 'Draft',
  default: 'Not sure..',
};


function formatButton(buttons, filterType, filter, setFilter) {
  const isSet = (filter[filterType] === true);
  const indicator = isSet ? (<i className="fa fa-square-o" aria-hidden="true" />) : (<i className="fa fa-check-square-o" aria-hidden="true" />);
  //const style = { color: EVENT_COLORS[filterType] };
  // const colorSwatch = (<i className="fa fa-square fa-stack-2x" aria-hidden="true" style={style} />);
  const filterDisplay = FILTER_NAMES[filterType];
  buttons.push(
    (<MenuItem
      key={filterType}
      onClick={setFilter}
      data-item={filterType}
      data-value={isSet}
    >
      {indicator} {filterDisplay}
    </MenuItem>),
  );
}

const FILTER_TYPES = ['AC', 'DR', 'AR'];

class TourFilterToolbar extends Component {
  constructor(props) {
    super(props);
    this.setFilter = this.setFilter.bind(this);
  }
  setFilter = (e) => {
    const filterType = e.currentTarget.getAttribute('data-item');
    const filterValue = e.currentTarget.getAttribute('data-value') === 'true';
    const newFilter = {};
    // TOGGLE the filter values
    newFilter[filterType] = !filterValue;
    this.props.tourFilterSet(newFilter);
  }

  render() {
    try {
      const buttons = [];
      const title = <span><i className="fa fa-filter" aria-hidden="true" /></span>;
      FILTER_TYPES.forEach((filterType) => {
        formatButton(buttons, filterType, this.props.filter, this.setFilter);
      });
      return (
        <DropdownButton title={title} id="bg-nested-dropdown">
          {buttons}
        </DropdownButton>
      );
    } catch (e) {
      console.log("TourFilter -> ", e);
      return null;
    }
  }
}
TourFilterToolbar.propTypes = {
  filter: PropTypes.object,
  tourFilterSet: PropTypes.func.isRequired,
};
TourFilterToolbar.defaultProps = {
  filter: {},
};

export default TourFilterToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/TourFilterDropDown.js